/**
 * One-shot race key for the next Race Summary mount.
 * Season Summary sets it when a race square is clicked; Race Summary reads it once.
 */
let pendingRaceKey: string | null = null;

export function setPendingRaceSummaryRace(raceKey: string | null | undefined): void {
  const key = String(raceKey ?? "").trim();
  pendingRaceKey = key && key !== "-1" ? key : null;
}

export function takePendingRaceSummaryRace(): string | null {
  const key = pendingRaceKey;
  pendingRaceKey = null;
  return key;
}
